import React from "react";

export const HELPER_TIMEOUT = 10000;

export const payment_type_options = [
  { value: "2", label: "Carta di credito (o PayPal)" },
  { value: "1", label: "SDD - Sepa Direct Debit" },
];

export const contractTypes = {
  flat: "Flat",
  rechargeable: "Ricaricabile",
  consumption: "AConsumo",
};

export const personTypeOptions = [
  { value: "1", label: "Persona fisica" },
  { value: "2", label: "Persona giuridica" },
];

export const defaultPersonType = "1";

export const isPhysicalPerson = (value) => {
  return value === "1";
};

export const getPrivacyInfo = (t) => {
  return {
    authComunicazioniPromo: t("privacy.promo"),
    authProfilazioneUtente: t("privacy.profilation"),
    authComunicazioneDati: t("privacy.authComunicazioneDati"),
  };
};

export const tcModalContent = {
  title: "Condizioni Generali",
  content: (
    <div className="text-justify">
      <div>
        Le seguenti Condizioni Generali di contratto si applicano a tutti i
        servizi forniti da Duferco Mobility S.r.l. (d’ora innanzi “Duferco”)
        attraverso l’applicazione “D-MOBILITY” e il sito{" "}
        <a
          href="https://mobility.dufercoenergia.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          mobility.dufercoenergia.com
        </a>
        . Il Cliente flaggando il tasto “Accedi” dichiara di essere persona
        fisica di maggiore età o persona giuridica e di avere attentamente letto
        ed espressamente accettato tutti i termini e le condizioni d’utilizzo
        dei servizi di seguito indicati (d’ora innanzi i “Servizi”).
      </div>
      <br />
      <div className="font-weight-600">Servizi forniti</div>
      <div>
        L’applicazione D-MOBILITY e/o il sito mobility.dufercoenergia.com
        consentono di gestire le seguenti operazioni:
        <ul>
          <li>
            visualizzazione su mappa delle stazioni di ricarica dedicate ai
            veicoli elettrici direttamente gestite da Duferco, abilitate ai
            servizi di ricarica di Duferco o da altro service provider italiano
            ed europeo con cui Duferco abbia concluso contratto di roaming;
          </li>
          <li>
            registrazione come Cliente e adesione al servizio di ricarica dei
            veicoli elettrici tramite smartphone e tablet. Per registrarsi come
            Cliente ed accedere all’utilizzo dei Servizi forniti è necessario
            compilare il modulo che apparirà sul video al momento della scelta
            dell'opzione "Registrati" e creare un proprio codice identificativo
            “Username" e "Password". Ai fini del buon esito della registrazione,
            il Cliente dovrà poi fornire i propri dati personali oltre ad
            indicare un metodo di pagamento che sarà utilizzato per il pagamento
            delle ricariche Pay per use (a consumo), l’acquisto delle soluzioni
            a contratto (es. abbonamento mensile o prepagata ricaricabile) ed
            eventuali servizi aggiuntivi o corrispettivi addizionali, come
            l’occupazione presa. Il trattamento dei dati avverrà nel rispetto
            delle disposizioni contenute Reg. UE 2016/679 (Regolamento Europeo
            per la protezione dei dati personali). Il Cliente dichiara e
            garantisce la completezza, correttezza e veridicità dei dati
            personali e di pagamento forniti in fase di registrazione, inclusa
            la titolarità a fruire di codici promozionali o convenzioni
            dedicate, e si impegna ad aggiornare gli stessi tempestivamente;
          </li>
          <li>
            sottoscrizione di offerte per la fornitura di servizi di ricarica
            per veicoli elettrici;{" "}
          </li>
          <li>
            acquisto ed associazione di una card RFID al profilo utente
            registrato;
          </li>
          <li>
            abilitazione alla ricarica a consumo, c.d. Pay per use, e pagamento
            del corrispettivo per il servizio di ricarica;
          </li>
          <li>
            abilitazione alla ricarica, grazie all’attivazione di codici
            promozionali e/o convenzioni;
          </li>
          <li>
            attivazione di opzioni di servizio rese disponibili anche in un
            momento successivo alla registrazione in App o in sito e alla
            sottoscrizione o acquisto delle soluzioni precedentemente citate;
          </li>
          <li>invio feedback sulla qualità del servizio erogato;</li>
          <li>
            invio richiesta contatto finalizzata al supporto nella ricarica;
          </li>
          <li>
            possibilità di contatto telefonico attraverso numero verde dedicato
            per l’assistenza;
          </li>
          <li>
            visualizzazione delle sessioni di ricarica e dei pagamenti
            effettuati;
          </li>
          <li>
            sblocco della presa da utilizzare ed avvio del processo di ricarica
            alla stazione selezionata (solo per talune stazioni di ricarica
            abilitate);
          </li>
          <li>
            monitoraggio del processo di ricarica (solo per talune stazioni di
            ricarica abilitate);
          </li>
          <li>
            interruzione del processo di ricarica mediante apposito comando
            dedicato (solo per talune stazioni di ricarica abilitate).
          </li>
        </ul>
        Duferco precisa che alcuni dei servizi sopraelencati potrebbero non
        essere disponibili al momento dell'accettazione delle presenti
        Condizioni Generali e che gli stessi potranno essere attivati in una
        fase successiva. La fatturazione dei servizi Mobility di Duferco è a
        cadenza mensile o superiore e copia della fattura verrà inviata al
        Cliente all’indirizzo di posta elettronica fornito. Per talune stazioni
        di ricarica, direttamente gestite da Duferco e visualizzabili tramite
        sito e/o App, è possibile l’abilitazione alla ricarica a sessione
        tramite SMS e il pagamento del corrispettivo per il servizio di ricarica
        tramite credito telefonico.
        <b> I termini e condizioni della ricarica tramite SMS sono consultabili <a href="https://www.ticketingpass.com/duferco-mobility/" target="_blank" rel="noreferrer">qui</a>. </b>
        <span>L’energia elettrica è garantita da fonte rinnovabile su rete Duferco Mobility.</span>
      </div>
      <br />
      <div className="font-weight-600">
         Extra soglia, corrispettivo addizionale e pre-autorizzazione
      </div>
      <div>
        In caso di fruizione di un’offerta in abbonamento mensile Flat o di
        offerta assimilabile che preveda una soglia periodica, al superamento
        della soglia di utilizzo mensile, Duferco si riserva di addebitare un
        importo indicato su base contrattuale per ogni incremento di
        disponibilità compreso fra 1 e 100 kWh da consumarsi nello stesso mese.
        In talune infrastrutture di ricarica pubblica, espressamente segnalate
        in App e sul sito, è prevista l’applicazione di un Corrispettivo
        Addizionale per occupazione presa (di seguito il “Corrispettivo
        Addizionale”) il cui importo è indicato nella scheda di dettaglio della
        singola infrastruttura di ricarica. Tale importo è da intendersi Esente
        IVA. Esclusivamente per le ricariche Pay per Use, all’avvio della ricarica, 
        sarà richiesta una pre-autorizzazione. Si precisa che, al termine della sessione, 
        sarà addebitato unicamente l’importo effettivamente utilizzato. 
        L’eventuale differenza tra l’importo pre-autorizzato e il costo effettivo 
        della sessione sarà rilasciata nei più brevi tempi previsti da ciascun istituto bancario.  
        Qualora il costo effettivo della sessione sia invece superiore all’importo pre-autorizzato, 
        l’ importo eccedente l’importo pre-autorizzato sarà richiesto da Duferco Mobility 
        srl successivamente ad ogni relativa sessione, al fine del pieno ripristino dei servizi.
      </div>
      <br />
      <div className="font-weight-600">Link</div>
      <div>
        Duferco può fornire link ad altri siti o ad altre risorse della rete
        Internet/Web. Il Cliente dà atto e riconosce che Duferco non può essere
        in alcun modo ritenuta responsabile per il funzionamento di tali siti o
        risorse esterne, né è tenuta a controllare il contenuto degli stessi e/o
        il materiale, anche pubblicitario, divulgatovi o i prodotti/Servizi ivi
        offerti, del cui eventuale acquisto il Cliente assume ogni
        responsabilità.
      </div>
      <br />
      <div className="font-weight-600">
        Divieto di rivendita o di uso commerciale dei Servizi
      </div>
      <div>
        Il diritto del Cliente di usare i Servizi sottoscritti è personale e non
        cedibile. Al Cliente è fatto divieto di rivendere o fare qualsiasi altro
        uso commerciale dei Servizi, senza il consenso scritto di Duferco.
      </div>
      <br />
      <div className="font-weight-600">
        Variazioni delle Condizioni Generali per modifiche normative e
        variazioni unilaterali di clausole contrattuali
      </div>
      <div>
        Le presenti Condizioni Generali prevalgono su qualunque accordo o intesa
        precedente intervenuta tra Duferco e il Cliente. Duferco si riserva il
        diritto di modificare le stesse qualora sia necessario per la corretta
        esecuzione dei Servizi, nonché di recepire in maniera automatica ogni
        obbligo imposto dalla legge o da provvedimenti di Pubbliche Autorità.
        Ove necessario Duferco indicherà al Cliente le conseguenti modifiche e i
        relativi effetti. Senza pregiudizio per le disposizioni precedenti,
        Duferco ha facoltà di apportare unilateralmente qualunque modifica alle
        condizioni economiche, normative o tecniche del contratto (quali, a
        titolo esemplificativo e non esaustivo, il mutamento delle condizioni
        del mercato o delle proprie politiche commerciali). L'uso di anche solo
        un Servizio da parte del Cliente costituirà una conferma della sua
        volontà di aderire alle Condizioni Generali e alle relative successive
        modificazioni.
      </div>
      <br />
      <div className="font-weight-600">Diritti di proprietà intellettuale</div>
      <div>
        Il Cliente riconosce espressamente che tutti i diritti di proprietà
        intellettuale, tutelabili sulla base delle norme relative al diritto
        d’autore o di altre disposizioni (fra cui, a titolo esemplificativo e
        non esaustivo, know-how, codice sorgente, software, hardware, progetti,
        applicativi, brevetti, segreti industriali, formule, algoritmi, modelli
        e banche dati relativi ai Servizi provenienti da Duferco o comunque
        messi a disposizione del Cliente in forza delle Condizioni Generali),
        sono e restano di titolarità di Duferco, e non potranno essere copiati,
        modificati, venduti e trasferiti a terzi.
      </div>
      <br />
      <div className="font-weight-600">
        Modalità di erogazione del servizio di ricarica ed interruzioni dello
        stesso
      </div>
      <div>
        Il servizio di ricarica potrà avvenire solo disponendo di un cavo a
        norma con spina di tipo 2 (generalmente detta ‘Mennekes’ monofase o
        trifase) o di tipo 3A (generalmente detta ‘Scame’, monofase) dotate di
        segnale pilota per la ricarica in Modo 3, o di presa lato vettura tipo
        Chademo e Combo 2 come richiesto dalle norme IEC 61851 per le ricariche
        in luogo pubblico. Il servizio di ricarica è erogato con continuità e
        può essere interrotto o ridotto di potenza temporaneamente da parte dei
        gestori di rete rispettivamente competenti per cause di oggettivo
        pericolo, per ragioni di servizio (quali, a titolo esemplificativo e non
        esaustivo, manutenzione, riparazione dei guasti, ampliamento,
        miglioramento o avanzamento tecnologico degli impianti) e per motivi di
        sicurezza ed efficienza e ottimizzazione del sistema. Tali interruzioni,
        nonché le interruzioni o limitazioni della fornitura dovute a cause
        accidentali, a cause di forza maggiore o comunque non imputabili a
        Duferco non comporteranno alcun obbligo di indennizzo o risarcimento né
        potranno costituire motivo di risoluzione del contratto. In particolare,
        Duferco non risponde dei danni conseguenti a problemi tecnici alla
        medesima non imputabili concernenti la consegna dell’energia elettrica
        quali, a titolo esemplificativo e non esaustivo, variazioni della
        tensione o frequenza della forma d’onda, interruzioni della continuità
        della fornitura o del servizio di trasmissione e distribuzione
        dell’energia elettrica, micro-interruzioni, buchi di tensione e, in
        generale, anomalie derivanti dalla gestione della connessione degli
        impianti del Cliente alla rete elettrica. Il Cliente dichiara, altresì,
        che il proprio veicolo è conforme agli standard di cui sopra e che il
        cavo e la presa a bordo veicolo sono stati forniti ed approvati dal
        costruttore del mezzo elettrico o sono comunque certificati e idonei
        alla ricarica del veicolo. Il mancato rispetto delle modalità di
        utilizzo previste e qualsiasi tentativo di uso improprio e/o
        manomissione del collegamento comporteranno l’immediata disabilitazione
        del servizio. Duferco si riserva di richiedere il risarcimento di
        qualsiasi danno derivante dall’utilizzo improprio e non conforme alle
        modalità specificate delle infrastrutture. Duferco risponderà
        esclusivamente di eventuali danni diretti causati al Cliente a seguito
        del verificarsi di un inconveniente tecnico nell’erogazione del servizio
        di ricarica nel limite euro 100.000,00 (centomila/00).
      </div>
      <br />
      <div className="font-weight-600">Manleva e garanzia</div>
      <div>
        Il Cliente si impegna ad utilizzare i Servizi esclusivamente per scopi
        leciti e ammessi dalle vigenti disposizioni di legge applicabili, in
        ogni caso senza ledere diritti di terzi ed assumendosi ogni
        responsabilità sul contenuto dei messaggi/feedback inviati. Il Cliente
        si obbliga a tenere indenne e a manlevare Duferco da ogni contestazione
        o risarcimento di oneri o danni che, direttamente o indirettamente,
        dovessero derivare alla stessa nell’ambito del presente contratto e che
        dipendano da fatto o comportamento del Cliente. Conseguentemente, il
        Cliente si obbliga a comunicare immediatamente a Duferco qualsiasi uso
        non autorizzato da parte di terzi del proprio User Id e/o Password o
        ogni altra violazione della sicurezza di cui venisse a conoscenza. Il
        Cliente riconosce che l’uso dei Servizi avviene a proprio esclusivo
        rischio. Duferco declina ogni responsabilità nel caso in cui i Servizi
        non corrispondano ai requisiti attesi dal Cliente o nel caso in cui gli
        stessi siano interrotti per qualsivoglia motivo alla stessa non
        addebitabile.
      </div>
      <br />
      <div className="font-weight-600">
        Sospensione e/o interruzione dei Servizi da parte di Duferco
      </div>
      <div>
        Duferco si riserva il diritto di sospendere o interrompere
        definitivamente l’erogazione dei Servizi in ogni momento, e senza
        preavviso alcuno, in caso di violazioni di legge o di inadempimento
        delle presenti Condizioni Generali da parte del Cliente.
      </div>
      <br />
      <div className="font-weight-600">Clausola di conservazione</div>
      <div>
        Qualora una clausola o una delle disposizioni delle presenti Condizioni
        Generali risulti invalida, inefficace o inapplicabile, essa non
        comporterà l’invalidità, l’inefficacia o lo scioglimento delle stesse,
        fatta salva l’applicazione dell’art. 1419, comma 1, cod. civ..
      </div>
      <br />
      <div className="font-weight-600">Legge applicabile e foro competente</div>
      <div>
        Per quanto non previsto dalle presenti Condizioni Generali, i Servizi
        forniti attraverso l’applicazione D-MOBILITY e il sito
        mobility.dufercoenergia.com sono regolati dalla legge italiana e dalla
        normativa specifica del settore. Per qualsiasi controversia dovesse
        insorgere tra Duferco e il Cliente in merito all’utilizzo dei Servizi
        forniti si farà ricorso al foro del consumatore per il Cliente persona
        fisica e al foro esclusivo di Genova per il Cliente persona giuridica.
      </div>
      <br />
      <div className="font-weight-600">Clausole vessatorie</div>
      <div>
        Il Cliente dichiara espressamente di accettare il contenuto delle
        seguenti clausole: (Extra soglia, corrispettivo addizionale e pre-autorizzazione);
        (Variazioni delle Condizioni Generali per modifiche normative e
        variazioni unilaterali di clausole contrattuali); (Modalità di
        erogazione del servizio di ricarica ed interruzioni dello stesso);
        (Manleva e garanzia); (Sospensione e/o interruzione dei Servizi da parte
        di Duferco); (Legge applicabile e foro competente).
      </div>
    </div>
  ),
};

export const privacyModalContent = {
  title:
    "Documento informativo ai sensi dell’art. 13 Reg. UE 2016/679 (GDPR) – Informativa per il trattamento dei dati personali raccolti presso l’interessato*",
  disclaimer:
    "* Informativa non valida per siti web eventualmente consultabili tramite links presenti sull’APP o sulla presente area a dominio del Titolare.",
  content: (
    <div className="text-justify">
      <div className="font-weight-600">
        1. Titolare del trattamento (artt. 4 e 24 GDPR)
      </div>
      <span className="font-weight-600">Duferco Mobility Srl</span>, con sede
      legale in Via Paolo Imperiale n. 4, 16126 Genova, in persona del legale
      rappresentante pro-tempore. Lei potrà contattare il Titolare ai seguenti
      contatti: fax +39 010.275.60200, email:{" "}
      <a href="mailto:privacy@d-mobility.it">privacy@d-mobility.it</a>, numero
      di telefono +39 010 275 601.
      <br />
      <br />
      <span className="font-weight-600">
        Responsabile della Protezione dei Dati (RPD/DPO – Data Protection
        Officer)
      </span>
      , ai sensi degli artt. 37 – 39 del GDPR, è individuato all’interno
      dell’organizzazione ed i relativi dati di contatto sono n. tel.: +39 010
      275 601; e-mail <a href="mailto:dpo@d-mobility.it">dpo@d-mobility.it</a>.
      <br />
      <br />
      <div className="font-weight-600">
        2. Categorie di dati personali trattati
      </div>
      <span className="font-weight-600">Dato personale:</span> qualsiasi
      informazione riguardante una persona fisica identificata o identificabile
      («interessato»); si considera identificabile la persona fisica che può
      essere identificata, direttamente o indirettamente, con particolare
      riferimento a un identificativo come il nome, un numero di
      identificazione, dati relativi all’ubicazione, un identificativo online o
      a uno o più elementi caratteristici della sua identità fisica,
      fisiologica, genetica, psichica, economica, culturale o sociale (art. 4,
      comma 1 n. 1 – C26, C27, C30 GDPR).
      <br />
      <br />
      <span className="font-weight-600">Dati di Pagamento:</span> dati necessari
      al fine di evadere un ordine, come i dati di carta di credito o bancomat
      (nome del titolare, numero della carta, data di scadenza, ecc.) o di altre
      forme di pagamento (se disponibili). In ogni caso, Duferco Mobility, o i
      consulenti che si occupano dei pagamenti per conto della stessa,
      gestiscono tali pagamenti e i dati finanziari nel rispetto delle leggi e
      delle normative in vigore e degli standard di Sicurezza come PCI DSS
      (Payment Card Industry Data Security Standard).
      <br />
      <br />
      <div className="font-weight-600">
        3. Finalità di trattamento/Base Giuridica – Periodo di conservazione
        dati e natura del conferimento
      </div>
      <br />
      <table className="table" style={{ border: "1px solid #dee2e6" }}>
        <thead>
          <tr>
            <th
              style={{
                verticalAlign: "inherit",
                backgroundColor: "#dee2e6",
                textAlign: "center",
                width: "500px",
              }}
            >
              FINALITÀ DEL TRATTAMENTO
            </th>
            <th
              style={{
                verticalAlign: "inherit",
                backgroundColor: "#dee2e6",
                textAlign: "center",
              }}
            >
              BASE GIURIDICA
            </th>
            <th
              style={{
                verticalAlign: "inherit",
                backgroundColor: "#dee2e6",
                textAlign: "center",
              }}
            >
              PERIODO CONSERVAZIONE DATI
            </th>
            <th
              style={{
                verticalAlign: "inherit",
                backgroundColor: "#dee2e6",
                textAlign: "center",
              }}
            >
              NATURA DEL CONFERIMENTO
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">A)</span> Accesso/utilizzo
              dell’area clienti e delle web APP di Duferco Mobility Srl, per la
              creazione di un account e per finalità amministrativo-contabili.
              L’APP potrà avere accesso anche ai seguenti dati: cronologia App;
              telefono; foto/elementi multimediali/file sul dispositivo, memoria
              esterna del dispositivo; fotocamera; informazioni sulla
              connessione; ID dispositivo; credenziali di accesso.
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                Art. 6 par. 1, lett. b) GDPR
              </span>
              <br />
              Contratto – adozione di misure precontrattuali adottate su
              richiesta dell’interessato
            </td>
            <td style={{ textAlign: "center" }}>
              Dati per la creazione e successivo utilizzo dell’account: fino
              alla disattivazione dell’account stesso.
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">Necessario</span>
              <br /> per poter accedere ed utilizzare l’area clienti/web APP. In
              caso di mancato conferimento, non potrà utilizzare le funzionalità
              offerte tramite l’area clienti/web APP.
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                B) Evasione della Sua richiesta di fornitura relativa ai servizi
                Duferco Mobility:
              </span>{" "}
              adempimento di obblighi contrattuali, di legge e attività
              amministrativo contabili correlate.Gestione di richieste di
              fornitura e/o servizi ulteriori che non necessitano di uno
              specifico contratto (es. richiesta di{" "}
              <span className="font-weight-600">
                ricariche occasionali, anche via SMS
              </span>
              )
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                Art. 6 par. 1, lett. b) GDPR
              </span>
              <br />
              Contratto <br /> (Richiesta di fornitura)
            </td>
            <td style={{ textAlign: "center" }}>
              10 anni dalla cessazione del contratto/rapporto di fornitura.
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">Necessario</span>
              <br /> per adempiere gli obblighi derivanti dal contratto. In caso
              di mancato conferimento non sarà possibile instaurare il
              contratto/rapporto di fornitura.
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">C)</span> Evasione eventuale{" "}
              <span className="font-weight-600">
                richiesta di assistenza o di informazioni
              </span>{" "}
              tramite form dedicati (es. per richiedere un contratto Flat e
              Ricaricabile o rilascio di feedback) o chiamando uno dei numeri
              verdi/contatti presenti sul sito (es. associazione di card al
              proprio account). In alcuni casi, per ragioni contrattuali o
              meramente tecniche, una volta creato l’account, sarà necessario
              contattare il Titolare ai numeri di supporto indicati per
              associare l’account alla propria card e fruire/accedere ai
              correlati servizi (es. Utilizzo del servizio di ricarica
              pubblica).
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                Art. 6 par. 1, lett. f) GDPR
              </span>
              <br />
              Legittimo interesse
            </td>
            <td style={{ textAlign: "center" }}>
              Non oltre 2 anni dall’inoltro della Sua richiesta
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">Necessario</span>
              <br /> per riscontrare la Sua richiesta. In caso di mancato
              conferimento non sarà possibile fornirLe l’assistenza e/o le
              informazioni richieste.
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                D) attività di marketing diretto del Titolare
              </span>{" "}
              dietro consenso da lei prestato, con invio di materiale
              pubblicitario/promozionale, vendita diretta di nuovi prodotti e
              servizi e/o questionari per la rilevazione del grado di
              soddisfazione tramite mezzi automatizzati di posta elettronica,
              telefax, messaggi del tipo Mms o Sms o di altro tipo (messagistica
              istanea, notifiche in App), nonché mediante telefonate tramite
              operatore e posta cartacea. <br /> <br /> Il Titolare per
              confrontare ed eventualmente migliorare i risultati delle
              comunicazioni, utilizza sistemi per invio di newsletter e
              comunicazioni promozionali con report. Grazie ai report il
              Titolare potrà conoscere, per esempio: il numero dei lettori,
              delle aperture, dei “cliccatori” unici e dei clic; i dispositivi
              ed i sistemi operativi utilizzati per leggere la comunicazione; il
              dettaglio sull’attività dei singoli utenti; il dettaglio delle
              email inviate, email recapitate e non, di quelle inoltrate. Tutti
              questi dati sono utilizzati allo scopo di confrontare, ed
              eventualmente migliorare, i risultati delle comunicazioni.
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                Art. 6 par. 1, lett. a) GDPR
              </span>
              <br />
              Consenso dell’interessato
            </td>
            <td style={{ textAlign: "center" }}>
              Fino a cessazione del contratto (o fino a revoca del consenso se
              antecedente)
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">Facoltativo</span> e{" "}
              <span className="font-weight-600">libero.</span>
              <br /> In mancanza, Lei potrà comunque usufruire dei servizi
              Mobility e di fornitura del Titolare.
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">E)</span> previo consenso,{" "}
              <span className="font-weight-600">profilazione</span>{" "}
              dell’interessato sulla base della tipologia consumi e correlate
              abitudini per ricevere offerte in linea con i Suoi interessi.
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                Art. 6 par. 1, lett. a) GDPR
              </span>
              <br />
              Consenso dell’interessato
            </td>
            <td style={{ textAlign: "center" }}>
              24 mesi (o fino a revoca del consenso)
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">Facoltativo</span> e{" "}
              <span className="font-weight-600">libero.</span>
              <br /> In mancanza, Lei potrà comunque usufruire dei servizi
              Mobility e di fornitura del Titolare.
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                F) Comunicazione/Cessione dei dati a terzi
              </span>{" "}
              (altre società del Gruppo e a Partner commerciali, con sede in
              Paesi SEE), per loro finalità di marketing diretto. Per elenco
              completo delle società del gruppo e partner, scrivere a{" "}
              <a href="mailto:privacy@d-mobility.it">privacy@d-mobility.it</a>.
            </td>
            <td style={{ textAlign: "center" }}>
              <span className="font-weight-600">
                Art. 6 par. 1, lett. a) GDPR
              </span>
              <br />
              Consenso dell’interessato
            </td>
            <td style={{ textAlign: "center" }}>
              Fino a revoca del consenso. Si rimanda inoltre alla informativa
              per il trattamento dati personali dei terzi Titolari autonomi del
              trattamento dati.
            </td>
            <td style={{ textAlign: "center" }}>
              Il conferimento è{" "}
              <span className="font-weight-600">facoltativo</span>. Il mancato
              conferimento dei dati necessari comporterà l’impossibilità di
              comunicare/cedere i dati a terzi per le loro finalità.
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <div className="font-weight-600">4. Cookies</div>
      Per maggiori informazioni consulta la sezione dedicata del presente sito
      web.
      <br />
      <br />
      <div className="font-weight-600">
        5. Destinatari/categorie di destinatari dei dati
      </div>
      I dati di natura personale forniti dal Cliente potranno essere comunicati
      a destinatari, che tratteranno i dati in qualità di Responsabili (art. 28
      GDPR) e/o in qualità di persone fisiche che agiscono sotto l’autorità del
      Titolare e del Responsabile (art. 29 GDPR), oppure che operano in totale
      autonomia come distinti Titolari del trattamento, al fine di ottemperare
      alle finalità perseguite da Duferco come sopra riportate. L’elenco dei
      Responsabili del trattamento designati è costantemente aggiornato e
      disponibile contattando il Titolare del Trattamento ai recapiti indicati
      in premessa. <br /> I dati potranno essere comunicati a destinatari
      appartenenti alle seguenti categorie: – Società controllanti/controllate
      e/o collegate a Duferco Mobility Srl; – Soggetti che forniscono servizi
      per la gestione del sistema informativo e delle reti di comunicazione di
      Duferco Mobility Srl (ivi compresa la posta elettronica ed il servizio di
      hosting) delle reti di telecomunicazioni e sviluppo dell’APP; – Società
      nell’ambito dei rapporti di assistenza e consulenza per la gestione
      dell’APP; – Studi o Società nell’ambito di rapporti di assistenza e
      consulenza nel settore marketing; - Istituti Finanziari e Assicurativi; –
      Autorità competenti per adempimenti di obblighi di legge e/o di
      disposizioni di organi pubblici, su richiesta; - società partner in
      specifiche iniziative commerciali.
      <br />
      <br />
      <div className="font-weight-600">
        6. Trasferimento dati verso un paese terzo
      </div>
      Nel caso di trasferimento dei Dati Personali al di fuori dell’Unione
      Europea verso Paesi considerati non adeguati dalla Commissione Europea,
      Duferco Mobility adotterà tutte le misure di sicurezza necessarie per
      proteggere i Dati Personali e fornirà garanzie adeguate per gli
      interessati ai sensi della normativa applicabile e, in particolare, degli
      articoli 45 e 46 del Regolamento EU 2016/679.
      <br />
      <br />
      <div className="font-weight-600">7. Diritti degli interessati</div>
      Lei potrà far valere i Suoi diritti come espressi dal Regolamento UE
      2016/679, contattando il Titolare all’indirizzo email{" "}
      <a href="mailto:privacy@d-mobility.it">privacy@d-mobility.it</a> oppure
      scrivendo al DPO all’indirizzo mail{" "}
      <a href="mailto:dpo@d-mobility.it">dpo@d-mobility.it</a>. Ha il diritto,
      in qualunque momento, di chiedere al Titolare del trattamento l’accesso ai
      Suoi dati personali (art. 15), la rettifica (art. 16) o la cancellazione
      (art 17) degli stessi, la limitazione del trattamento (art 18). Le è
      inoltre riconosciuto il diritto alla portabilità del dato, ove previsto
      (art. 20): in tal caso, il Titolare Le fornirà in un formato strutturato,
      di uso comune e leggibile, da dispositivo automatico, i dati personali che
      la riguardano. Inoltre, ha il diritto di opporsi in qualsiasi momento al
      trattamento di dei suoi dati (inclusi trattamenti automatizzati, es.
      profilazione). Nello specifico, per revocare i consensi prestati potrà
      scrivere in qualsiasi momento un’e-mail all’indirizzo{" "}
      <a href="mailto:privacy@d-mobility.it">privacy@d-mobility.it</a>. In
      alternativa potrà anche utilizzare i nostri sistemi di
      cancellazione/modifica automatica presenti sulle applicazioni.
      <br />
      <br />
      <div>
        Fatto salvo ogni altro ricorso amministrativo e giurisdizionale, se
        ritiene che il trattamento dei dati che la riguardano violi il Reg. UE
        2016/679, ai sensi dell’art. 15 lettera f), Lei ha il diritto di
        proporre reclamo all’Autorità di Controllo, ovvero il Garante Italiano
        per la protezione dei dati personali (
        <a href="https://www.garanteprivacy.it/">
          https://www.garanteprivacy.it/
        </a>
        ) e, con riferimento all’art. 6 paragrafo 1, lettera a), ha il diritto
        di revocare in qualsiasi momento il consenso prestato scrivendo al
        Titolare e/o al DPO secondo le modalità sopra descritte.
      </div>
      <br />
      <span className="font-weight-600">Data di aggiornamento:</span> 02 Aprile
      2024
      <br />
    </div>
  ),
};

/* eslint-disable */
export const modalContents = {
  3: {
    title: "CONDIZIONI ECONOMICHE E ACCETTAZIONE ESPRESSA DI CLAUSOLE",
    content: (
      <div className="text-justify">
        <div>
          Il Cliente sopra identificato propone a Duferco Energia S.p.A. (il
          “Fornitore”) di concludere un contratto per la fornitura di energia
          elettrica e/o gas secondo i termini, le condizioni e i prezzi indicati
          nella presente richiesta di fornitura (la “Richiesta Di Fornitura”).
          Le condizioni di fornitura di energia elettrica e gas sono
          disciplinate nelle Condizioni Generali di fornitura “DE-CGDualFuel-
          052018”, disponibili anche sul sito{" "}
          <a
            href="https://www.dufercoenergia.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.dufercoenergia.com
          </a>{" "}
          che costituiscono parte integrante del contratto assieme agli
          allegati: A) Condizioni Tecnico Economiche di Fornitura, B) Richiesta
          di Inserimento punti aggiuntivi (per forniture di 2 o più POD/PDR), D)
          Modalità di pagamento, E) il modulo “Dati Catastali” (da compilare ed
          inviare a Duferco Energia entro novanta giorni); F) Informativa e
          consenso al trattamento dei dati personali ai sensi dell’art. 13, e,
          per chi ne ha diritto, il “Modulo Accise”. La Richiesta di Fornitura è
          proposta irrevocabile per 45 giorni dalla sottoscrizione della stessa,
          decorso il quale termine deve considerarsi revocata. Il contratto si
          intenderà concluso solo nel momento in cui il Fornitore, che rimane
          libero di non accettare, comunica al Cliente l’accettazione della
          Richiesta Di Fornitura. La data di inizio della fornitura verrà
          comunicata dal Fornitore. Ai sensi e per gli effetti di cui agli
          articoli 1341 e 1342 del codice civile il cliente dichiara ad ogni
          effetto di legge, di conoscere ed accettare espressamente le
          condizioni di cui all’allegato A), nonché tutte le condizioni di
          vendita di questa richiesta e dei suoi ulteriori allegati sopra
          citati. Ai sensi e per gli effetti di cui agli artt. 1341 e 1342 cod.
          civ. il Cliente dichiara di conoscere e approvare espressamente anche
          le seguenti clausole delle “Condizioni Generali di fornitura”: Art. 3
          (Perfezionamento del contratto); Art. 4 (Requisiti di solvibilità del
          cliente e garanzia del credito); Art. 11 (Fatturazione e pagamenti);
          Art. 16 (Risoluzione del contratto); Art. 17 (Cessione del contratto,
          subentro nel contratto e divieto di sub-fornitura); Art. 20
          (Limitazioni di responsabilità e impossibilità sopravvenuta della
          prestazione); Art. 25 (Legge applicabile e Foro territoriale
          competente).
        </div>
      </div>
    ),
  },
  4: {
    title:
      "NOTA INFORMATIVA PER IL CLIENTE FINALE (ai sensi del Codice di Condotta Commerciale del. ARERA n. 104/10)",
    content: (
      <div className="text-justify">
        <div>
          Tutti i clienti sono liberi di scegliere il proprio fornitore di
          energia elettrica e/o di gas naturale. Aderendo al contratto che Le è
          stato sottoposto o sottoscrivendo la relativa proposta contrattuale
          Lei entrerà/rimarrà nel mercato libero. Se Lei è un cliente domestico
          di gas naturale o comunque un cliente avente diritto al servizio di
          tutela (ad esempio un cliente domestico), l’esercente la vendita è
          sempre tenuto ad informarla della possibilità di richiedere
          l’applicazione delle condizioni economiche e contrattuali fissate
          dall’Autorità di Regolazione per Energia Reti e Ambiente, in
          alternativa all’offerta attuale. Se Lei è un cliente domestico
          elettrico o una PMI, Lei ha sempre la possibilità di richiedere
          all’esercente il servizio di maggior tutela della sua località, in
          alternativa all’offerta attuale, l’attivazione del servizio a
          condizioni economiche e contrattuali fissate dall’Autorità di
          Regolazione per Energia Reti e Ambiente. Per garantire che i clienti
          dispongano degli elementi necessari per poter consapevolmente
          scegliere, l’ARERA ha emanato un Codice di condotta commerciale che
          impone a tutte le imprese di vendita precise regole di comportamento.
          Per ulteriori informazioni sul Codice di condotta commerciale e più in
          generale sui diritti del cliente può visitare il sito{" "}
          <a
            href="https://www.arera.it"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.arera.it
          </a>{" "}
          o chiamare il numero verde 800.166.654. Di seguito vengono riassunte,
          come promemoria, le informazioni che devono essere fornite nel corso
          della presentazione di una offerta contrattuale:
        </div>
        <div className="font-weight-bold mt-4">
          1) IDENTITA’ DELL’IMPRESA E DELL’OPERATORE COMMERCIALE
        </div>
        <div>
          Nome impresa; indirizzo utile anche per l’invio di reclami scritti o
          dell’esercizio dei diritti di ripensamento; codice identificativo o
          nome del personale commerciale che l’ha contattata; data e ora del
          contatto; firma del personale commerciale che l’ha contattata.
        </div>
        <div className="font-weight-bold mt-4">
          2) SCADENZE ED EVENTUALI ONERI PER L’ATTIVAZIONE DEL CONTRATTO
        </div>
        <div>
          Data di presunta attivazione; periodo di validità della proposta;
          eventuali oneri a carico del Cliente.
          <br />
          NOTA: in caso di proposta contrattuale del cliente domestico o cliente
          PMI, se l’impresa di vendita non invia l’accettazione della proposta
          entro 45 (quarantacinque) giorni dalla sottoscrizione da parte del
          cliente, la proposta si considera decaduta.
        </div>
        <div className="font-weight-bold mt-4">3) CONTENUTO DEL CONTRATTO</div>
        <div>
          Il contratto che Le è stato proposto deve sempre contenere almeno le
          seguenti clausole: prezzo del servizio; durata del contratto; modalità
          di utilizzo dei dati di lettura; modalità e tempistiche di pagamento;
          conseguenze del mancato pagamento; eventuali garanzie richieste;
          modalità e tempistiche per l’esercizio dei diritti di recesso;
          modalità per ottenere informazioni, presentare un reclamo o risolvere
          una controversia con l’impresa di vendita.
        </div>
        <div className="font-weight-bold mt-4">
          DOCUMENTI DA CONSEGNARSI OLTRE ALLA PRESENTE NOTA INFORMATIVA
        </div>
        <div>Copia contratto.</div>
      </div>
    ),
  },
  5: {
    title:
      "DICHIARAZIONE SOSTITUTIVA DELL'ATTO DI NOTORIETÀ (Art 47 D.P.R. 28 dicembre 2000, n. 445)",
    content: (
      <div className="text-justify">
        <div>
          Il Cliente, consapevole delle sanzioni penali richiamate dall'art.76
          del d.P.R. 28.12.2000 n.445, in caso di dichiarazioni mendaci e di
          formazione o uso di atti falsi, DICHIARA di avere titolo attestante la
          proprietà e/o il regolare possesso e/o la regolare detenzione
          dell'unità immobiliare ubicata presso l'indirizzo di fornitura sopra
          indicato per la quale richiede l'allacciamento dei servizi di Energia
          Elettrica e/o Gas Naturale.
        </div>
      </div>
    ),
  },
  6: {
    title: "DELEGA PER RECESSO",
    content: (
      <div className="text-justify">
        <div>
          Il Cliente, conformemente a quanto previsto dalla delibera ARERA n
          783/2017/R/com dichiara la propria decisione di recedere dal contratto
          o dai contratti di somministrazione dallo stesso stipulati con altro
          fornitore aventi ad oggetto i punti di prelievo della presente
          proposta. A tal proposito il Cliente DELEGA il nuovo fornitore, in
          persona dei relativi legali rappresentanti, a compiere, a proprio nome
          e per proprio conto, tutti gli atti necessari a disdire i contratti di
          fornitura in essere con il vecchio fornitore, nel rispetto delle
          modalità e dei tempi sopra richiamati e solo successivamente al
          termine previsto dal proprio "diritto di ripensamento", che se
          esercitato renderà inefficace la presente delega.
        </div>
      </div>
    ),
  },
};
